import React from 'react';
import { cx } from './cx';
import type { AdminTone } from './tokens';

export interface AdminStatCardProps {
  label: React.ReactNode;
  value: React.ReactNode;
  /** icon lucide 20px trong ô 40px bo 12px */
  icon?: React.ReactNode;
  tone?: AdminTone;
  hint?: React.ReactNode;
  className?: string;
}

// Thẻ số liệu: ô icon nền nhạt theo họ màu, nhãn 13px 500 xám, số 24px 700.
export const AdminStatCard = ({ label, value, icon, tone = 'brand', hint, className }: AdminStatCardProps) => (
  <div className={cx('adm-stat', className)}>
    <span className={cx('adm-stat__icon', `adm-stat__icon--${tone}`)} data-testid="adm-stat-icon" aria-hidden="true">
      {icon}
    </span>
    <div className="adm-stat__body">
      <div className="adm-stat__label">{label}</div>
      <div className="adm-stat__value">{value}</div>
      {hint && <div className="adm-stat__hint">{hint}</div>}
    </div>
  </div>
);

// Lưới thẻ số liệu: 4 cột mặc định (2 cột dưới 1024px, 1 cột trên điện thoại).
export const AdminStatGrid = ({
  cols = 4,
  className,
  children,
}: {
  cols?: 2 | 3 | 4;
  className?: string;
  children: React.ReactNode;
}) => <div className={cx('adm-stat-grid', cols !== 4 && `adm-stat-grid--${cols}`, className)}>{children}</div>;

export default AdminStatCard;
